import { sign_key, getCryptoJSResult } from '@/api/common'
import { isObj } from '@/utils/tool'
import { globalVariable } from '@/utils/exportVariable'
import { getEnv } from './env'
import { add, sub } from './accurateNumber'

const md5 = require('md5')

export function getPostSignKey(params) {
  return getCryptoJSResult(sign_key, JSON.stringify(params))
}

// 给GET方法生成Kicoin-Sign
export function getSignKey(options) {
  const keys = Object.keys(options).sort()
  try {
    let sign_str = ''
    for (let key of keys) {
      sign_str = sign_str + key + '=' + decodeURIComponent(options[key]) + '&'
    }
    return getCryptoJSResult(sign_key, sign_str + sign_key)
  } catch (error) {
    //反馈页发送长串特殊字符decodeURIComponent会报错，比如下面的字符
    //~！@￥%……&*（）——·1234567890-==去玩儿拖与【】】】从VB你们，。、qwertyuiopasdfghjklzxcvbnm{}:"<>?+qawedrftgyhuj【；‘，。、{}|：“”》？’】
    let _sign_str = ''
    for (let key of keys) {
      _sign_str = _sign_str + key + '=' + options[key] + '&'
    }
    return getCryptoJSResult(sign_key, _sign_str + sign_key)
  }
}

// 获取get中url的参数
export function getParams(url) {
  let query = {}
  if (url.indexOf('?') != -1) {
    const str = url.substr(url.indexOf('?')).substr(1)
    const pairs = str.split('&')
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i].split('=')
      query[pair[0]] = pair[1]
    }
  }
  return query
}

function conver(str, offset) {
  const charCode = str.charCodeAt(0)
  // 替换大写字母 A-Z:65-90
  if (charCode <= 90 && charCode >= 65) {
    return String.fromCharCode(
      charCode + offset < 90 ? charCode + offset : charCode - offset
    )
  } else {
    //替换小写字母 a-z:97-122
    return String.fromCharCode(
      charCode + offset < 122 ? charCode + offset : charCode - offset
    )
  }
}

function string2Number(str = '') {
  const strArr = str.split('')
  const numberArr = strArr.filter((item) => /[0-9]/.test(item))
  return numberArr
}

function formatParams(options) {
  let { url = '', data = {}, method, headers = {}, params } = options || {}
  const contentType = headers['content-type'] || ''
  const isPostJson = contentType.indexOf('application/json') > -1
  const isPostForm =
    contentType.indexOf('application/x-www-form-urlencoded') > -1
  // post json请求中，拼接的是整个body体
  if (method === 'post' && isPostJson) {
    data = JSON.stringify(data)
  }
  // post form请求中，key=value升序方式拼接
  if (method === 'post' && isPostForm) {
    const querys = {}
    data = decodeURIComponent(data)
    data.split('&').forEach((item) => {
      const query = item.split('=')
      querys[query[0]] = query[1]
    })
    let queryStr = ''
    Object.keys(querys)
      .sort()
      .forEach((item, index) => {
        queryStr += `${item}=${querys[item]}${
          index < Object.keys(querys).length - 1 ? '&' : ''
        }`
      })
    data = queryStr
  }
  if (method === 'get') {
    const querys = { ...params }
    const urlQuerys = {}
    if (url.indexOf('?') > -1) {
      url
        .split('?')[1]
        .split('&')
        .forEach((item) => {
          const query = item.split('=')
          urlQuerys[query[0]] = query[1]
        })
    }

    let queryStr = ''
    const allQuery = { ...querys, ...urlQuerys }
    Object.keys(allQuery)
      .sort()
      .forEach((item, index) => {
        queryStr += `${item}=${allQuery[item]}${
          index < Object.keys(allQuery).length - 1 ? '&' : ''
        }`
      })

    url = url.split('?')[0]
    data = queryStr
  }
  let keyString = url.indexOf('?') > -1 ? url + '&' : url + '?'

  if (isObj(data)) {
    // 对key进行排序，保证每次都一样
    const keys = Object.keys(data).sort()
    keys.forEach((key, index) => {
      if (index !== keys.length - 1) {
        keyString += key + '=' + data[key] + '&'
      } else {
        keyString += key + '=' + data[key]
      }
    })
  } else {
    keyString += data
  }
  return keyString
}

export function publicKey(options = {}, extraInfos = {}) {
  let keyString = ''
  if (extraInfos && Object.keys(extraInfos).length) {
    keyString = `${formatParams(options)}&${extraInfos['X-AppId']}${
      extraInfos['X-Timestamp']
    }${extraInfos['X-Nonce']}`
  } else {
    keyString = formatParams(options)
  }
  const md5String = md5(keyString)
  const numArr = string2Number(md5String)

  let max = 3,
    min = 3
  if (numArr.length === 0) {
    if (isObj(options)) {
      max = min = Object.keys(options.data || {}).length
    }
  } else {
    max = Math.max.apply(Math, numArr)
    min = Math.min.apply(Math, numArr)
  }
  const offset = max + min
  let key = ''
  md5String.split('').forEach((item) => {
    if (/[0-9]/.test(item)) {
      key += item
    } else {
      key += conver(item, offset)
    }
  })

  return key
}
/**
 * 生成请求头中的签名参数
 * @param {*} options 请求参数
 * @param {*} type 区分是init接口，还是其他普通的接口
 * @returns
 */
export function encryptionParameters(options, type) {
  const appid = '101'
  const urlParams = formatParams(options)
  const {
    auth = '',
    encryptedRandom = '',
    serverTime = 0,
    responseTime = 0,
  } = getApiSign()
  const currentTs = new Date().getTime()
  const diffTs = sub(currentTs, responseTime)
  const requestTime = add(serverTime, diffTs)
  const timestamp = type === 'init' ? currentTs : requestTime
  const nonce = timestamp.toString(16) || ''
  // apmTrackTimestampExpireError({
  //   serverTime,
  //   currentTs,
  //   options,
  //   responseTime,
  // })

  const hmackey = publicKey(options, {
    'X-AppId': appid,
    'X-Timestamp': timestamp,
    'X-Nonce': nonce,
  })

  const randomKey = type === 'init' ? '' : decrypt(encryptedRandom || '')
  const originDatas = `${urlParams}&${appid}${timestamp}${nonce}${hmackey}`
  const signature = getCryptoJSResult(
    `${hmackey}${randomKey}`,
    `${originDatas}${randomKey}`
  )
  return {
    'X-AppId': appid,
    'X-Timestamp': timestamp,
    'X-Nonce': nonce,
    'X-Signature': signature,
    ...(auth ? { 'X-Auth': auth } : {}),
  }
}
// 获取init接口返回的值
export function getApiSign() {
  const { common = {} } = globalVariable?.store?.state || {}
  return common?.apiSign || {}
}
// rsa解密encryptedRandom 获取盐值
export function decrypt(pw) {
  const privatekey_prod =
    'MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBALleRUnb6lJEQnEwxbcnx0f8nRwQpYAevT1NSwW1/V9olk5ZI3IYAe4vHDzaJnSk5j9Ir1P0lmcxS/GsdXBjpPkvwwO7M/mGzalbJXbBjqbsdVm7ifS5orDbjPCT98FHqNWgS8b/ac8iZMOvVVa02Ii39NoQj70uTDhsMosQv9VVAgMBAAECgYEAgoB+8We1CSPrTvsSR0bnAqQzC74gdhmuCwluht/AOLpOD2ysCrgiK8jY7XJ73mT1gJowbT/l31KSb9uFdpGAY4VcFK8ok+PfvWpp7dyTDi7csiyQN/1jgywB2xLQ4++kKkfhMfJsoiQsP6dD2W5dPcMPncNfAKMwlFHVG0nkFEUCQQD3suo/ZXcuxTbXau9HXEZ/DhU5/9VbVXFtQiNMOlAU1kfF6qV5mT/JZQffyZnocLCW0J0H9UXhb1pVr68B9NoHAkEAv5SaFCj/ovHXYQbV5XcoGCnHiteU1jkjF42X+89FTqzWD3Kddejb6WxI1TatBeUcZscvsfieHbum1CCLwUuuwwJAQhXE84cRpjPNrumDz2kqEcnjFedQuB5ytbC4lCTWqsiEu6Qf4/JkF0pSMH2sB1zRcFtWGgJxU3UPB99odMArzwJBAJwKKjEPb5/FQPrLOX6rveFobhl9G8IcSaPOdSLpIHdDORrd7Lhz0GJgCzZ2URkDEk34ILXhXM+03t3aIFpxDUcCQGuzO3WhS0mRtFdVE3zjUUh+XyA2ZrQCblsw3H+dPWQ9edUB4e88pn9YdMSNvMrQ8rMQ7OBq4E7x+w4Ygu7Eqyk='
  const privatekey_dev =
    'MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAKRc7ZIe6Y8eNPez1G1MWyZPNeYtlS6DkMBhavyuOOf+JVxUIugFybVqFpx1jmuPbNuzo5PLYYPFi9O0Y7q1unxzhRIcLyVLM5kWVkE17OH6jXcxVgzp0qsmiIZpZSoeoqs2tOuiPz1gY6Ha9uA/W/7x6jeQisDHeLbQwUeJRlNJAgMBAAECgYB5OAgGckHyyWZrIPeUPHIlCNpJjmity15gY/iRrrRNdQR82Zh84nfnEfznG1QUQ80XI5+Kir66fmEnm6zJsOl9W5mD1Fheagx8tq/bWuR3TnD/6QQ6Y/Dp5IaDwKzD56tD2CWhDaUSI6UJ0/0cO0uNlYM7ZzE080Zvv3iWNVcvAQJBAOE1O7ZK50JyOqT+0lGM1J6Mu1jKYBVlrAbQcwCrq2Kszd7UHFA3C4v2RrYqU6VD1x8KT0yMY1DsqzyrIZv6SDECQQC61f1eyFuN97Ttkp2lO0W69N4oCNAXxNWSGYIkPQZVFgROqkKmWe5ZT0Dua59cIyV6H11meHAE9kbN3owjho6ZAkEAm9olKrCHflpi71BR6JHXiqnF9VqISAaGmGilTa9/+dew2SZdOb3+Rav3n5WHMXXTZ+3Qlx8IlDZVArVDmxgH4QJAaZ75inCn2V0Uak29UyBr7iHpySYaRaWfuuUyvjvFbapxqurznMkwRkrYgTBUOakg0aYTjg89/IAhTNan0JmL2QJBAIwngq5FWVyDArMeS1HVnI3JVxZe67OBKNm6NuV+KMLwNKZOGCSarfqds+DPnSNrXK1tKP+qO0McLQAMcowSYSg='

  try {
    let _JSEncrypt = null
    if (process.client) {
      _JSEncrypt = JSEncrypt
    } else {
      _JSEncrypt = require('node-jsencrypt')
    }
    if (_JSEncrypt) {
      const encryptor = new _JSEncrypt()

      encryptor.setPrivateKey(
        getEnv() === 'test' ? privatekey_dev : privatekey_prod
      )
      return encryptor.decrypt(pw)
    } else {
      /* eslint-disable */
      console.log(`_JSEncrypt 不存在, 当前是客户端：${process.client}`)
    }
  } catch (error) {
    //eslint-disable-next-line
    console.log('node-jsencrypt:====>', error)
  }
}

// function apmTrackTimestampExpireError(params = {}) {
//   if (!process.client) {
//     return
//   }
//   const {
//     serverTime = 0,
//     currentTs = 0,
//     options = {},
//     responseTime = 0,
//   } = params
//   // 前端时间 - 服务端时间
//   const diffTs = currentTs - serverTime
//   const hour = 24 * 60 * 60 * 1000

//   if (Math.abs(diffTs) > hour) {
//     const { $apm = {} } = globalVariable
//     const errorMsg = `<<<前后端时间戳不一致报错>>>: 服务端时间戳: ${serverTime}, 前端时间戳: ${currentTs}, init接口响应时间: ${responseTime}, 其他参数: ${JSON.stringify(
//       options
//     )}`
//     $apm.captureError && $apm.captureError(new Error(errorMsg))
//   }
// }
